module.exports = __webpack_public_path__ + "static/media/1.337f7ec4.png";